/* Calendar-day delivery estimates. No visitor deadline or countdown. */
(function (root) {
  'use strict';
  function estimate(now, minDays, maxDays, locale) {
    const min = Math.max(0, Math.trunc(Number(minDays) || 4));
    const max = Math.max(min, Math.trunc(Number(maxDays) || 7));
    const day = offset => new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset, 12);
    const from = day(min), to = day(max);
    const format = new Intl.DateTimeFormat(locale || 'en-US', {month:'short', day:'numeric'});
    const dateRange = typeof format.formatRange === 'function'
      ? format.formatRange(from, to)
      : format.format(from) + ' – ' + format.format(to);
    return {from, to, dateRange};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {estimate}; return; }
  const config = root.Lagom?.config;
  if (!config?.eta?.enabled) return;
  let refreshTimer;
  function refresh() {
    const now = new Date();
    const info = estimate(now, config.eta.min, config.eta.max, config.locale);
    const text = config.eta.arrival.replace('[date]', info.dateRange);
    document.querySelectorAll('[data-eta]').forEach(eta => {
      const title = eta.querySelector('[data-eta-days]');
      const note = eta.querySelector('[data-eta-sub]');
      if (title && title.textContent !== text) title.textContent = text;
      if (note && !note.hasAttribute('data-eta-custom-note') && note.textContent !== config.eta.note) note.textContent = config.eta.note;
      eta.dataset.etaFrom = [info.from.getFullYear(),info.from.getMonth()+1,info.from.getDate()].join('-');
      eta.dataset.etaTo = [info.to.getFullYear(),info.to.getMonth()+1,info.to.getDate()].join('-');
    });
    // Refresh dates when the calendar day changes, including long-lived tabs.
    root.clearTimeout(refreshTimer);
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    refreshTimer = root.setTimeout(refresh, midnight.getTime() - now.getTime() + 100);
  }
  refresh();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', refresh);
})(typeof window !== 'undefined' ? window : globalThis);
